export const Loading = ({size}: {size?: number}) => {
  const sizeString = `h-${size || 24} w-${size || 24}`
  return (
    <div className="m-auto select-none">
      <img className={`${sizeString}`} src="/assets/images/loading.gif" alt="loading" />
    </div>
  );
};
